const scoreRender = props => {
    const { row, productHandle } = props;
    const training = JSON.parse(row['fields.trained'] || {});
    const allAp = row.assignmentProgressList || [];

    const assignmentHandle = row['assignmentProgress.assignmentHandle'];
    const testScore = assignmentHandle && row[`assignmentProgress.variables.${assignmentHandle}_test_score`];
    if (testScore) {
        return testScore;
    }

    if (training[productHandle]) {
        return 'Training Toggled';
    }

    const aelLabelMapper = {
        ael_k_training: 'AEL K Training',
        ael_1_training: 'AEL 1 Training',
        ael_2_training: 'AEL 2 Training',
        ael_3_training: 'AEL 3 Training',
        ael_4_training: 'AEL 4 Training',
        ael_5_training: 'AEL 5 Training',
    };
    if (
        productHandle.startsWith('ael') &&
        allAp.some(ap => ap.completed && ap.completedDate && ap.deployment.deploymentHandle.startsWith('ael_'))
    ) {
        const completedAp = allAp.find(ap => ap.completed && ap.deployment.deploymentHandle.startsWith('ael_'));
        return 'Completed ' + aelLabelMapper[completedAp.deployment.deploymentHandle];
    }

    if (
        productHandle === 'ssgrin_k2' &&
        allAp.some(ap => ap.completed && ap.deployment.deploymentHandle === 'ssgrin_35_training')
    ) {
        return 'Completed S.S. Grin 3-5';
    }

    if (
        productHandle === 'ssgrin_35' &&
        allAp.some(ap => ap.completed && ap.deployment.deploymentHandle === 'ssgrin_k2_training')
    ) {
        return 'Completed S.S. Grin K-2';
    }

    if (productHandle.startsWith('ael') && Object.keys(training).some(k => k.startsWith('ael') && training[k])) {
        const completedProductHandle = Object.keys(training).find(k => k.startsWith('ael') && training[k]);
        return 'Completed ' + aelLabelMapper[completedProductHandle + '_training'];
    }

    if (productHandle === 'ssgrin_k2' && training.ssgrin_35) {
        return 'Completed S.S. Grin 3-5';
    }

    if (productHandle === 'ssgrin_35' && training.ssgrin_k2) {
        return 'Completed S.S. Grin K-2';
    }

    return '';
};

export default scoreRender;
